import React, { useState } from "react";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import { styled } from "@mui/material/styles";
import { Theme } from "@mui/material/styles";

import Grid from "@mui/material/Grid";
import Switch from "@mui/material/Switch";

interface QuestionTypeSelectorProps {
    questionTypes: Array<any>;
    selectedQuestionTypes: Array<any>;
    handleChange: any;
    adaptable: boolean;
    setAdaptable: Function;
}

const AntSwitch = styled(Switch)(({ theme }: { theme: Theme }) => ({
    width: 28,
    height: 16,
    padding: 0,
    display: "flex",
    "& .MuiSwitch-switchBase": {
        padding: 2,
        color: theme.palette.grey[500],
        "&.Mui-checked": {
            transform: "translateX(12px)",
            color: theme.palette.common.white,
            "& + .MuiSwitch-track": {
                opacity: 1,
                backgroundColor: theme.palette.primary.main,
                borderColor: theme.palette.primary.main
            }
        }
    },
    "& .MuiSwitch-thumb": {
        width: 12,
        height: 12,
        boxShadow: "none"
    },
    "& .MuiSwitch-track": {
        border: `1px solid ${theme.palette.grey[500]}`,
        borderRadius: 16 / 2,
        opacity: 1,
        backgroundColor: theme.palette.common.white
    }
}));

export default function QuestionTypeSelector({
    adaptable,
    handleChange,
    questionTypes,
    selectedQuestionTypes,
    setAdaptable
}: QuestionTypeSelectorProps) {
    return (
        <div className="row">
            <div className="quizzer-topbar-label">Question Types</div>
            <Grid component="label" container alignItems="center" spacing={1}>
                <Grid container item xs={12} md={6} className="question-type-selector__mode">
                    <Grid item>Select Types</Grid>
                    <Grid item>
                        <AntSwitch
                            checked={adaptable}
                            onChange={() => {
                                setAdaptable(!adaptable);
                            }}
                            name="adaptable"
                        />
                    </Grid>
                    <Grid item>Adaptable</Grid>
                </Grid>
                <Grid container item xs={12} md={6} className="question-type-selector__choices">
                    {adaptable === false ? (
                        <ToggleButtonGroup
                            value={selectedQuestionTypes}
                            onChange={handleChange}
                            aria-label="text formatting"
                        >
                            {questionTypes.map((questionType, i) => {
                                return (
                                    <ToggleButton
                                        key={i}
                                        color="primary"
                                        value={questionType.slug}
                                    >
                                        {questionType.text}
                                    </ToggleButton>
                                );
                            })}
                        </ToggleButtonGroup>
                    ) : (
                        <span>
                            Modquiz will select question types based on your
                            skill level of the material.
                        </span>
                    )}
                </Grid>
            </Grid>
        </div>
    );
}
// <Select
//     options={questionTypes.map(
//         (sqt: any) => {
//             return {
//                 value: sqt.slug,
//                 label: sqt.text
//             };
//         }
//     )}
//     value={selectedQuestionTypes.map(
//         (sqt: any) => {
//             return {
//                 value: sqt.slug,
//                 label: sqt.text
//             };
//         }
//     )}
//     onChange={handleChange}
//     isMulti={true}
// />
